import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repository/RepositoryFactory";

export const addPizzaMoneyByCsv =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const ticketsRepository = RepositoryFactory.get("addPizzaMoney");
      const response = await ticketsRepository.addPizzaMoney(data);
      console.log("===>", response);
      if (response.data.success) {
        dispatch({
          type: "PIZZA_MONEY_RESPONSE",
          payload: response?.data?.data,
        });
        onComplete("success");
      } else {
        onComplete("error");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log(error);
      onComplete();
    }
  };

export const addPizzaMoneyBySingle =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const ticketsRepository = RepositoryFactory.get("addPizzaMoney");
      const response = await ticketsRepository.addPizzaMoney(data);
      if (response.data.success) {
        dispatch({
          type: "PIZZA_MONEY_RESPONSE",
          payload: response?.data?.data,
        });
        toast.success(response?.data?.message);
        onComplete("success");
      } else {
        toast.success(response?.data?.message);
        onComplete("error");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log(error);
      onComplete();
    }
  };

export const getPizzaMoneyData =
  (id, lastDocument, onComplete = () => {}) =>
  (dispatch) => {
    let moreData = firebase
      .firestore()
      .collection("pizza-money-athletes")
      .where("schoolAdminId", "==", id)
      .orderBy("createdAt");
    if (lastDocument !== "") {
      moreData = moreData.startAfter(lastDocument);
    }
    moreData
      .limit(10)
      .get()
      .then(async (query) => {
        let pizzaMoneyData = [];

        for await (let doc of query.docs) {
          pizzaMoneyData.push({ id: doc.id, ...doc.data() });
        }
        dispatch({
          type:
            lastDocument != "" ? "MORE_PIZZA_MONEY_DATA" : "PIZZA_MONEY_DATA",
          payload: {
            data: pizzaMoneyData,
            lastDocument: query.docs[pizzaMoneyData.length - 1],
            hasMoreDocument: pizzaMoneyData.length >= 10,
          },
        });
        onComplete();
        // console.log(newArr)
      });
  };

// export const getPizzaMoneyAthletes = (athleteId, lastDocument, onComplete = () => {}) =>
//   async (dispatch) => {
//     console.log(athleteId)
//     let moreData = firebase
//       .firestore()
//       .collection("pizza-money-athletes")
//       .where("athleteId", "==", athleteId)
//       .orderBy("createdAt");
//     if (lastDocument !== "") {
//       moreData = moreData.startAfter(lastDocument);
//     }
//     moreData.limit(10).get().then(async (query) => {
//         let pizzaMoneyAthletes = [];

//         for await (let doc of query.docs) {
//           pizzaMoneyAthletes.push({ id: doc.id, ...doc.data() });
//         }
//         dispatch({
//           type: lastDocument != "" ? 'MORE_PIZZA_MONEY_ATHLETES' : 'PIZZA_MONEY_ATHLETES',
//           payload: {
//             data: pizzaMoneyAthletes,
//             lastDocument: query.docs[pizzaMoneyAthletes.length - 1],
//             hasMoreDocument: pizzaMoneyAthletes.length >= 10,
//           },
//         });
//         onComplete();
//         // console.log(newArr)
//       });
//   };
